import type { Banner, BannerId } from '@app/shared/types/banner'

import { defineStore } from 'pinia'

export const useBannerManager = defineStore('bannerManager', {
  state: (): { activeBanners: Record<string, Banner> } => ({
    activeBanners: {},
  }),
  actions: {
    raiseBanner(banner: Banner) {
      this.activeBanners[banner.id] = banner
    },
    dismissBanner(bannerId: BannerId) {
      delete this.activeBanners[bannerId]
    },
    dismissAll() {
      Object.keys(this.activeBanners).forEach((bannerId) => {
        delete this.activeBanners[bannerId]
      })
    },
  },
  getters: {},
})
